import { Flows } from '../../flows/flows';
import type { AllFlows } from '../../types/flows/AllFlows';

export const isValidFlowName = (flow: string | null | undefined): flow is keyof AllFlows => {
  return !!flow && flow in Flows;
};
